import { useEffect, useRef, useState } from "react";

/**
 * Tiny inline "Copy" affordance for ids/hashes/urls. Sits next to monospace
 * values; flips to "Copied" for a moment after a successful copy.
 */
export function CopyButton({ value, label }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => setCopied(false), 1400);
    } catch {
      /* clipboard can be blocked (http / permissions); value stays selectable */
    }
  }

  return (
    <button
      type="button"
      className={`copy-btn${copied ? " copied" : ""}`}
      onClick={(e) => {
        e.stopPropagation();
        void copy();
      }}
      title={`Copy ${label ?? "value"}`}
      aria-label={`Copy ${label ?? "value"} to clipboard`}
    >
      {copied ? "Copied" : "Copy"}
    </button>
  );
}
